module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v2_common/close-e97a94af749bcb7e15d7d11fdd5a0267.svg";